import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, MenuItemLabel } from '@/components/gluestack/menu';
import { Icon, CheckIcon } from '@/components/gluestack/icon';
import { ButtonWrapper } from '@/components/ui/ButtonWrapper';
import { nearbyFilterOptions, type NearbyFilterOption } from '@/constants/lists';

interface NearbyFilterSelectorProps {
  filterOption: NearbyFilterOption;
  onFilterChange: (filter: NearbyFilterOption) => void;
}

export function NearbyFilterSelector({ filterOption, onFilterChange }: NearbyFilterSelectorProps) {
  const { t } = useTranslation();

  return (
    <Menu
      placement="bottom left"
      crossOffset={-4}
      offset={8}
      trigger={({ ...triggerProps }) => (
        <ButtonWrapper
          {...triggerProps}
          text={t(`people.nearbyFilter.${filterOption}`)}
          size="sm"
          variant="solid"
          action="primary"
          className="px-2.5 py-1.5 h-auto shrink rounded-full"
        />
      )}>
      {nearbyFilterOptions.map((option) => (
        <MenuItem
          key={`nearbyFilter-menuItem-${option}`}
          textValue={t(`people.nearbyFilter.${option}`)}
          onPress={() => onFilterChange(option)}>
          <MenuItemLabel>{t(`people.nearbyFilter.${option}`)}</MenuItemLabel>
          {option === filterOption && <Icon as={CheckIcon} size="sm" className="ml-2" />}
        </MenuItem>
      ))}
    </Menu>
  );
}

